import { useMutation } from '@tanstack/react-query'

import { deleteMerchantGeneralBlockAllowedOrganizationIds } from '@src/api'
import { DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useDeleteMerchantGeneralBlockAllowedOrganizationIds = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (
      params: DefaultApiDeleteMerchantGeneralBlockAllowedOrganizationIdsRequest
    ) =>
      deleteMerchantGeneralBlockAllowedOrganizationIds(axiosInstance, params),
  })
}
